module.exports = __webpack_public_path__ + "img/csv.4660e6bb.svg";